import axios from 'axios'
// import qs from 'qs'

const BASE_URL = 'https://us-central1-identical-faces.cloudfunctions.net'

// const LOGIN_URL = BASE_URL + '/auth/jwt'
// const ENROLL_URL = BASE_URL + '/faces/enroll'
// const IDENTIFY_URL = BASE_URL + '/faces/identify'
const COMPARE_URL = '/compare'

const instance = axios.create({
    baseURL: BASE_URL
})

function compare(url1, url2) {
    return instance.get(COMPARE_URL, {
            params: {
                url1, url2
            }
        })
}

export { compare }


// WEBPACK FOOTER //
// ./src/compare.js